import { customAxios, customPatchAxios } from "./customAxios";

/**
 * 설비스펙 목록
 * @param {*} equipmentId 
 * @returns 
 */
export const getEquipmentSpecsByEquipmentId = async(equipmentId)=>{
  const res = await customAxios.get(`/api/equipment/${equipmentId}/specs`);
  if (res.data) {
     return res.data;
  }
  return null;
}

/**
 * 최근 설비스펙
 * @param {*} equipmentId 
 * @returns 
 */
export const getLastEquipmentSpec = async(equipmentId)=>{
  const res = await customAxios.get(`/api/equipment/${equipmentId}/specs/latest`);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 최근 등록된 스팩의 파징된 데이터
 * @param {*} equipmentId 
 * @returns 
 */
export const getLastEquipmentSpecParsed = async(equipmentId)=>{
  const res = await customAxios.get(`/api/equipment/${equipmentId}/specs/latest/parsed`);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 스팩 파징된 데이터
 * @param {*} equipmentId 
 * @returns 
 */
export const getEquipmentSpecParsedBySpecId = async(equipmentId, specId)=>{
  const res = await customAxios.get(`/api/equipment/${equipmentId}/specs/${specId}/parsed`);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}





/**
 * 설비스펙 등록
 * @param {*} equipmentId, body 
 */
export const postEquipmentSpecs = async(equipmentId, body)=>{
 //console.log(body);
  const res = await customAxios.post(`/api/equipment/${equipmentId}/specs`, body);
  if (res.data) {
    return res.data;
  }
  return null;
}


/**
 * 설비스펙 삭제
 * @param {*} equipmentId, specId 
 */ 
export const deleteEquipmentSpecs = async(equipmentId, specId)=>{
  //console.log(body);
  await customAxios.delete(`/api/equipment/${equipmentId}/specs/${specId}`);
}
